module.exports = __webpack_public_path__ + "img/weddingbands.e6335c9.webp";